import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { urlPaths } from "../../utils/config";

const StickyCTA = () => {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setIsVisible(true);
  }, [location.pathname]);

  const includedRoutes = [
    urlPaths.homepage,
    urlPaths.comingsoon,
    urlPaths.comingsoon2,
    urlPaths.homenew,
    urlPaths.commenterhome,
    urlPaths.aboutUs,
    urlPaths.results,
    urlPaths.feature,
    urlPaths.pricing,
    urlPaths.contactUs,
    urlPaths.privacyPolicy,
    urlPaths.termsOfService,
  ];

  if (!includedRoutes.includes(location.pathname) || !isVisible) return null;

  return (
    <div className="fixed bottom-0 w-full bg-[#002157]  z-50 border-t border-[#E2E8F0]">

      <div className="w-full relative py-2 sm:py-3 px-3 sm:px-6 shadow-xl flex flex-col sm:flex-row gap-3 sm:gap-0 items-center justify-between">
        {/* CTA Text */}
        <p className="text-white font-medium text-lg sm:text-xl text-center sm:text-left">
          Start getting more opportunities
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto items-center">

          {/* <button
            onClick={() => navigate("/register")}
            className="w-full sm:w-auto px-4 py-2 rounded-md text-white text-sm sm:text-base font-medium bg-gradient-to-r from-[#6366F1] to-[#8B5CF6]"
          >
            Schedule a demo
          </button> */}

          <button
            onClick={() => navigate("/register")}
            className="w-full sm:w-auto px-4 py-2 rounded-md text-[#1B1E54] text-sm sm:text-base font-medium bg-white border"
          >
            Try Commenter.ai for free
          </button>

          {/* Close button */}
          <button
            onClick={() => setIsVisible(false)}
            className="absolute top-2 right-2 sm:static text-white font-bold text-xl hover:text-red-700"
          >
            ✕
          </button>


        </div>
      </div>
    </div>
  );
};

export default StickyCTA;
